// @ts-nocheck

import React from 'react'
import { Button } from '@xprog/prensa'
import * as t from './ItemButton.types'
import * as S from './ItemButton.styled'

const ItemButton: React.FC<t.ItemMenuProps> = (props) => {
  return (
    <S.Container customCss={props.cssContainer}>
      <a href={props.href} title={props.value} target='_blank' rel='noreferrer'>
        <Button
          {...props.default}
          {...props.customProps}
          css={{
            ...props.defaultCss,
            ...props.customCss,
            ...(props.hideInMobile && {
              display: 'none',
              '@lg': { display: 'flex' }
            }),
            ...(props.hideInDesktop && { '@lg': { display: 'none' } })
          }}
        >
          {props.value || props.children}
        </Button>
      </a>
    </S.Container>
  )
}

ItemButton.defaultProps = {
  default: {
    onClick: (e) => console.log(e),
    size: 'xs',
    variant: 'ghost'
  },
  defaultCss: {
    button: {
      px: 0
    },
    label: {
      fontSize: '12px',
      fontWeight: 400,
      fontFamily: '$primary',
      px: '0',
      mr: '$6'
    }
  },
  hideInMobile: true
}

export default ItemButton
